import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Chart from 'react-google-charts';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import moment from 'moment';
import Card from '../../Cards';
import FilterDropdown from '../../Modal/FilterDropdown';
import { countBy, getDate, getChartData } from './DatesAnalytics';

let weekStart = moment().startOf('isoWeek');
let weekDays = [];
for (let i = 0; i <= 6; i++) {
  weekDays.push(moment(weekStart).add(i, 'days').format('dddd D'));
}

export default function ChartMessages({ analyticsMessage }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [option, setOption] = useState('week');
  const [apply, setApply] = useState(false);
  const mobile = useMediaQuery('(max-width: 580px)')

  const initial = getChartData(analyticsMessage, 'messages', 'week');
  const [data, setData] = useState(initial);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOption = (event, option) => {
    setApply(false);
    setOption(option);
    setData(getChartData(analyticsMessage, 'messages', option));
    setAnchorEl(null);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <FilterDropdown
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        handleOption={handleOption}
        option={option}
      />

      <div style={{ marginBottom: 24, minHeight: 528 }}>
        <Card
          title="Personas interesadas en tus servicios"
          subtitle1={getDate(option)}
          subtitle2={`${countBy(option, analyticsMessage)} personas`}
          filter={true}
          link={
            analyticsMessage.length > 0 ? (
              <Link
                to="/dashboard/mensajes"
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                Ver mis mensajes
              </Link>
            ) : (
              false
            )
          }
          linkPosition="bottom"
          dropdown={handleClick}
        >
          <div style={{ marginBottom: 60, marginTop: 10 }}>
            <Chart
              width={'100%'}
              height={'350px'} //350
              chartType="LineChart"
              loader={<div style={{marginBottom:16}}>Cargando gráfica...</div>}
              data={
                data
                  ? data
                  : [
                      ['Dia', 'Mensajes', { role: 'style' }],
                      [weekDays[0], 0, `point { fill-color: #35b9b6; }`],
                      [weekDays[1], 0, `point { fill-color: #35b9b6; }`],
                      [weekDays[2], 0, `point { fill-color: #35b9b6; }`],
                      [weekDays[3], 0, `point { fill-color: #35b9b6; }`],
                      [weekDays[4], 0, `point { fill-color: #35b9b6; }`],
                      [weekDays[5], 0, `point { fill-color: #35b9b6; }`],
                      [weekDays[6], 0, `point { fill-color: #35b9b6; }`],
                    ]
              }
              options={{
                chartArea: {
                  width: '90%',
                  height: '70%',
                  top: 35,
                  backgroundColor: 'transparent',
                },
                legend: 'none',
                colors: ['#013957'],
                hAxis: {
                  textStyle: {
                    fontName: 'Lato',
                    bold: true,
                    color: '#10587f',
                    fontSize: mobile? 9:11,
                  },
                  format: 'ddd D',
                },
                vAxis: {
                  minValue: 10,
                  textStyle: {
                    fontName: 'Lato',
                    bold: true,
                    color: '#10587f',
                    fontSize: 11,
                  },
                  baseline: {
                    color: '#e7e7e7',
                  },
                },
                pointSize: 7,
              }}
              rootProps={{ 'data-testid': '1' }}
            />
          </div>
        </Card>
      </div>
    </>
  );
}
